import { topics } from '@/mocks/home';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950">热门话题</h2>
          <p className="mt-2 text-sm text-foreground-500">看看大家都在讨论哪些韩漫类型</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic) => (
            <a
              key={topic.name}
              href="#index"
              className={`group flex items-center gap-2 px-5 py-2.5 rounded-full border transition-all cursor-pointer whitespace-nowrap ${
                topic.hot
                  ? 'border-primary-300 bg-primary-50 text-primary-700 hover:bg-primary-100 hover:border-primary-400'
                  : 'border-background-200 bg-background-50 text-foreground-600 hover:border-foreground-300 hover:bg-background-100'
              }`}
            >
              <span className="text-sm font-medium">{topic.name}</span>
              {topic.hot && (
                <span className="inline-flex items-center gap-0.5 text-xs text-accent-600">
                  <i className="ri-fire-line text-[10px]"></i>
                </span>
              )}
              <span className="text-xs text-foreground-400">{topic.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}